function news_link_listener_page() {
    document.querySelectorAll('div.row.article , .col-12.article.paginateItem').forEach(elem => {
        const linkElem = elem.querySelector('a[href]');
        if (linkElem) {
            elem.addEventListener('click', (ev) => {
                window.location.href = linkElem.href;
            });
        }
    });
}

document.addEventListener('DOMContentLoaded', function (event) {
    news_link_listener_page();
});